module.exports = __webpack_public_path__ + "static/lead_hero_image-73f965046e632df460edef96708c754b.jpg";